// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"165":"330f6cea","488":"516cb54c","823":"486f2d06"}[chunkId] + ".chunk.js");